import React from 'react';
import App from 'app';
import paths, { rootPaths } from './paths';
import { Navigate, createBrowserRouter } from 'react-router-dom';
// import AuthSimpleLayout from '../layouts/authSimpleLayout';
import MainLayout from '../layouts/mainLayout';
import ErrorLayout from '../layouts/errorLayout';

import Error404 from 'components/errors/error404';
import Error500 from 'components/errors/error500';
import SplitLogin from 'components/authentication/split/login';
// import SplitRegistration from 'components/authentication/split/registration';
import SplitForgetPassword from 'components/authentication/split/forgetPassword';
import SplitPasswordReset from 'components/authentication/split/passwordReset';
import Relations from 'components/relations/relations';
import NewRelation from 'components/relations/newRelation';
import EditRelation from 'components/relations/editRelation';
import RelationDetails from 'components/relations/relationDetails';
import Proposals from 'components/proposals/proposals';
import NewProposal from 'components/proposals/newProposal';
import EditProposal from 'components/proposals/editProposal';
import ProposalDetails from 'components/proposals/proposalDetails';
import ProposalEmailValidation from 'components/proposals/proposalEmailValidation/proposalEmailValidation';
import Support from 'components/support/support';
import Faq from 'components/support/faq';
import Users from 'components/administration/users';
import NewUser from 'components/administration/newUser';
import UserDetails from 'components/administration/userDetails';
import EditUser from 'components/administration/editUser';
import Profile from 'components/profile/profile';
import PasswordResetForm from 'components/authentication/passwordResetForm';
import ReleaseNotes from 'components/release-notes/releaseNotes';
import Settings from 'components/administration/settings/settings';
import PrivateRoute from './privateRoute';
import Dashboard from 'components/clean2U-dashboard/dashboard';
import Calender from 'components/calender/calender';
import AddNewOrder from 'components/orders/addNewOrder';
import Orders from 'components/orders/order';
import OrderDetails from 'components/orders/orderDetails';
import EditOrder from 'components/orders/editOrder';
import Actvity from 'components/administration/activity';
import Task from 'components/workTasks/task';
import NewWorkTask from 'components/workTasks/newTask';
import Inventries from 'components/administration/inventry/inventries';
import TaskDetails from 'components/workTasks/taskDetails';
import EditTask from 'components/workTasks/editTask';
import Jobs from 'components/jobs/jobs';
import EmployeeDashboard from 'components/clean2U-dashboard/employeeDashboard';
import ClientDashboard from 'components/clean2U-dashboard/clientDashboard';
import HoursRegistration from 'components/reports/hoursRegistration';
import Notifications from 'components/notifications/notifications';
import Templates from 'components/administration/templates/templates';
import SubscriptionRenewal from 'components/subscriptions/subscriptionRenewal';
import PaymentResult from 'components/subscriptions/paymentResult';
import MySubscription from 'components/subscriptions/mySubscription';
import Absence from 'components/reports/absence';
import Attendance from 'components/reports/attendance';
import Invoices from 'components/billings/invoices'
import MyTimesheet from 'components/clean2U-dashboard/myTimesheet'

const routes = [
  {
    element: <App />,
    children: [
      {
        index: true,
        element: <Navigate to={paths.login} replace />,
      },
      {
        path: paths.validateProposal,
        element: <ProposalEmailValidation />,
      },
      {
        path: rootPaths.errorsRoot,
        element: <ErrorLayout />,
        children: [
          {
            path: paths.error404,
            element: <Error404 />,
          },
          {
            path: paths.error500,
            element: <Error500 />,
          },
        ],
      },
      {
        path: rootPaths.authRoot,
        children: [
          {
            path: paths.login,
            element: <SplitLogin />,
          },
          // {
          //   path: paths.register,
          //   element: <SplitRegistration />,
          // },
          {
            path: paths.forgotPassword,
            element: <SplitForgetPassword />,
          },
          {
            path: paths.splitResetPassword,
            element: <SplitPasswordReset />,
          },
          {
            path: rootPaths.authSplitRoot,
            children: [
              // {
              //   path: paths.splitLogin,
              //   element: <SplitLogin />
              // },
              // {
              //   path: paths.splitRegister,
              //   element: <SplitRegistration />
              // },
              {
                path: paths.splitForgotPassword,
                element: <SplitForgetPassword />,
              },
              {
                path: paths.SplitPasswordReset,
                element: <SplitPasswordReset />,
              },
            ],
          },
        ],
      },
      {
        path: "/",
        element: (
          <PrivateRoute>
            <MainLayout />
          </PrivateRoute>
        ),
        children: [
          {
            index: true,
            element: (
              <PrivateRoute>
                <Relations />
              </PrivateRoute>
            ),
          },
          {
            path: rootPaths.relationsRoot,
            element: (
              <PrivateRoute>
                <Relations />
              </PrivateRoute>
            ),
          },
          {
            path: rootPaths.relationsRoot,
            children: [
              {
                path: paths.newRelation,
                element: (
                  <PrivateRoute>
                    <NewRelation />
                  </PrivateRoute>
                ),
              },
              {
                path: paths.relationDetails,
                element: (
                  <PrivateRoute>
                    <RelationDetails />
                  </PrivateRoute>
                ),
              },
              {
                path: paths.relationDetailsByProposalId,
                element: (
                  <PrivateRoute>
                    <RelationDetails />
                  </PrivateRoute>
                ),
              },
              {
                path: paths.editRelation,
                element: (
                  <PrivateRoute>
                    <EditRelation />
                  </PrivateRoute>
                ),
              },
            ],
          },
          {
            path: rootPaths.proposalsRoot,
            element: (
              <PrivateRoute>
                <Proposals />
              </PrivateRoute>
            ),
          },
          {
            path: rootPaths.proposalsRoot,
            children: [
              {
                path: paths.newProposal,
                element: (
                  <PrivateRoute>
                    <NewProposal />
                  </PrivateRoute>
                ),
              },
              {
                path: paths.newProposalByRelationId,
                element: (
                  <PrivateRoute>
                    <NewProposal />
                  </PrivateRoute>
                ),
              },
              {
                path: paths.editProposal,
                element: (
                  <PrivateRoute>
                    <EditProposal />
                  </PrivateRoute>
                ),
              },
              {
                path: paths.proposalDetails,
                element: (
                  <PrivateRoute>
                    <ProposalDetails />
                  </PrivateRoute>
                ),
              },
              {
                path: paths.proposalDetailsByRelationId,
                element: (
                  <PrivateRoute>
                    <ProposalDetails />
                  </PrivateRoute>
                ),
              },
            ],
          },
          {
            path: rootPaths.planningRoot,
            element: (
              <PrivateRoute>
                <Calender />
              </PrivateRoute>
            ),
          },
         {
            path: rootPaths.myTimesheetRoot,
            element: (
              <PrivateRoute>
                <MyTimesheet />
              </PrivateRoute>
            ),
          },
          {
            path: rootPaths.orderRoot,
            element: (
              <PrivateRoute>
                <Orders />
              </PrivateRoute>
            ),
          },
          {
            path: rootPaths.orderRoot,
            children: [
              {
                path: paths.newOrder,
                element: (
                  <PrivateRoute>
                    <AddNewOrder />
                  </PrivateRoute>
                ),
              },
              {
                path: paths.orderDetails,
                element: (
                  <PrivateRoute>
                    <OrderDetails />
                  </PrivateRoute>
                ),
              },
              {
                path: paths.editOrder,
                element: (
                  <PrivateRoute>
                    <EditOrder />
                  </PrivateRoute>
                ),
              }
            ],
          },
          {
            path: rootPaths.supportRoot,
            element: (
              <PrivateRoute>
                <Support />
              </PrivateRoute>
            ),
          },
          {
            path: rootPaths.faq,
            children: [
              {
                path: paths.faq,
                element: (
                  <PrivateRoute>
                    <Faq />
                  </PrivateRoute>
                ),
              },
            ],
          },
          {
            path: rootPaths.usersRoot,
            element: (
              <PrivateRoute>
                <Users />
              </PrivateRoute>
            ),
          },
          {
            path: rootPaths.newUser,
            children: [
              {
                path: paths.newUser,
                element: (
                  <PrivateRoute>
                    <NewUser />
                  </PrivateRoute>
                ),
              },
              {
                path: paths.editUser,
                element: (
                  <PrivateRoute>
                    <EditUser />
                  </PrivateRoute>
                ),
              },
              {
                path: paths.userDetails,
                element: (
                  <PrivateRoute>
                    <UserDetails />
                  </PrivateRoute>
                ),
              },
            ],
          },
          {
            path: rootPaths.settingsRoot,
            element: (
              <PrivateRoute>
                <Settings />
              </PrivateRoute>
            ),
          },
          {
            path: rootPaths.invoiceRoutes,
            element: (
              <PrivateRoute>
                <Invoices />
              </PrivateRoute>
            ),
          },
          {
            path: rootPaths.hoursRegistration,
            element: (
              <PrivateRoute>
                <HoursRegistration />
              </PrivateRoute>
            ),
          },
          {
            path: rootPaths.leaveManagementRoot,
            element: (
              <PrivateRoute>
                <Absence />
              </PrivateRoute>
            ),
          },
          {
            path: rootPaths.myLeavesRoot,
            element: (
              <PrivateRoute>
                <Absence />
              </PrivateRoute>
            ),
          },
          {
            path: rootPaths.attendanceRoot,
            element: (
              <PrivateRoute>
                <Attendance />
              </PrivateRoute>
            ),
          },
          {
            path: rootPaths.profileRoot,
            element: (
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            ),
          },
          {
            path: rootPaths.notificationsRoot,
            element: (
              <PrivateRoute>
                <Notifications />
              </PrivateRoute>
            ),
          },
          {
            path: rootPaths.releaseNotesRoot,
            element: (
              <PrivateRoute>
                <ReleaseNotes />
              </PrivateRoute>
            ),
          },
          {
            path: rootPaths.dashboardRoot,
            element: (
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            ),
          },
          {
            path: paths.employeeDashboard,
            element: (
              <PrivateRoute>
                <EmployeeDashboard />
              </PrivateRoute>
            ),
          },
          {
            path: paths.clientDashboard,
            element: (
              <PrivateRoute>
                <ClientDashboard />
              </PrivateRoute>
            ),
          },
          {
            path: rootPaths.activityRoot,
            element: (
              <PrivateRoute>
                <Actvity />
              </PrivateRoute>
            ),
          },

          {
            path: rootPaths.workTasksRoot,
            element: (
              <PrivateRoute>
                <Task />
              </PrivateRoute>
            ),
          },
          {
            path: paths.newTask,
            element: (
              <PrivateRoute>
                <NewWorkTask />
              </PrivateRoute>
            ),
          },
          {
            path: paths.taskDetails,
            element: (
              <PrivateRoute>
                <TaskDetails />
              </PrivateRoute>
            ),
          },
          {
            path: paths.editTask,
            element: (
              <PrivateRoute>
                <EditTask />
              </PrivateRoute>
            ),
          },
          {
            path: rootPaths.jobsRoot,
            element: (
              <PrivateRoute>
                <Jobs />
              </PrivateRoute>
            ),
          },
          {
            path: rootPaths.inventoryRoot,
            element: (
              <PrivateRoute>
                <Inventries />
              </PrivateRoute>
            ),
          },
           {
            path: rootPaths.templatesRoot,
            element: (
              <PrivateRoute>
                <Templates />
              </PrivateRoute>
            ),
          },
          {
            path: rootPaths.mySubscriptionRoot,
            element: (
              <PrivateRoute>
                <MySubscription />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: rootPaths.subscriptionRoot,
        
          children: [
            {
              path: paths.renewSubscriptionRoot,
              element: <SubscriptionRenewal />,
            }
          ]
      },
      {
        path: rootPaths.paymentRoot,
        
          children: [
            {
              path: paths.paymentResult,
              element: <PaymentResult />,
            }
          ]
      },
      {
        path: "*",
        element: <Navigate to={paths.error404} replace />,
      },
    ],
  },
];

export const router = createBrowserRouter(routes, {
  basename: process.env.PUBLIC_URL
});

export default routes;